import './styles.css';
import { createApp } from 'vue';
import { createPinia } from 'pinia';
import App from './App.vue';

const el = document.getElementById('ebus-manufacturers-app');
if (el) {
    const app = createApp(App, { mapSvg: atob(el.dataset.map || '') });
    app.use(createPinia());
    app.mount(el);
}
